import React from 'react';

import SocialProof from './SocialProof';

import type { SocialProofFragment } from '@xingternal/pages-common';


import map from 'lodash.map';

type SocialProofContainerProps = {
  socialProof?: SocialProofFragment | null;
  pageId: string;
};

const toUserList = (socialProof: SocialProofFragment) => {
  const userNodes = socialProof.edges;
  const users = userNodes ? map(userNodes, 'node.xingId') : undefined;

  return users?.map((user) => ({
    id: user.id,
    profileName: user.displayName,
    src: user?.profileImage[0]?.url,
    href:
      user?.clickReasonProfileUrl?.profileUrl || `/profile/${user.pageName}`,
  }));
};

const socialProofData = (socialProof: SocialProofFragment) =>
  socialProof
    ? {
        users: toUserList(socialProof),
        total: socialProof.total,
        proofType: socialProof.proofType,
      }
    : undefined;

const SocialProofContainer = ({ socialProof, pageId, ...props }: SocialProofContainerProps) => {
  if (!(socialProof && socialProof?.total > 0)) {
    return null;
  }

  return (
    <div data-cy={'socialProof'}>
      <SocialProof
        pageId={pageId}
        socialProofData={socialProofData(socialProof)}
        {...props}
      />
    </div>
  );
};

export default SocialProofContainer;
